export default __webpack_public_path__ + "static/media/chronic-pain.3766a131.png";